import { useLazyQuery } from '@apollo/client';
// Api
import { GET_MERCH_CART_ITEM_LIST } from 'api/merch/queries';
// Types
import { GetMerchCartItemsList } from 'api/merch/types/GetMerchCartItemsList';

export const useLazyGetMerchCartItemList = () => {
  return useLazyQuery<GetMerchCartItemsList>(GET_MERCH_CART_ITEM_LIST, {
    fetchPolicy: 'network-only',
  });
};
